<!--产品特色-->
<template>
  <div class="comp-feature">
    <!-- 内容区 -->
    <div class="cont">
      <img src="@/assets/feature/f-01.jpg">
      <img src="@/assets/feature/f-02.jpg" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/54/101.pdf">
      <img src="@/assets/feature/f-03.jpg">
      <img src="@/assets/feature/f-04.jpg" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/42/101.pdf">
      <img src="@/assets/feature/f-05.jpg">
      <img src="@/assets/feature/f-06.jpg">
      <img src="@/assets/feature/f-07.jpg" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/45/101.html">
      <img src="@/assets/feature/f-08.jpg">
      <img src="@/assets/feature/f-09.jpg" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/55/101.html">
      <img src="@/assets/feature/f-10.jpg">
      <img src="@/assets/feature/f-11.jpg" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/53/101.html">
      <img src="@/assets/feature/f-12.jpg">
      <p class="first">注：</p>
      <p>1.本产品使用条款包括：</p>
      <p>（1）《平安i康保个人（慢病版）医疗保险条款》，报备文号为平保健发〔2020〕110号，条款编码为平安健康〔2020〕医疗保险018号。</p>
      <p>（2）《平安附加质子重离子医疗保险条款》，报备文号为平保健发〔2019〕101号，条款编码为平安健康〔2019〕医疗保险007号。</p>
      <p>（3）《平安特定恶性肿瘤药品费用医疗保险条款》，报备文号为平保健发〔2019〕159号，条款编码为平安健康〔2019〕医疗保险013号。</p>
      <p>2.本产品接受的投保年龄为18至55周岁，重新投保年龄最高可至99周岁；</p>
      <p>3.被保险人在等待期结束前被确诊罹患的疾病所导致的医疗费用，无论此等费用是否发生在等待期内，我们都不承担本主险合同所有保险金的赔付责任。</p>
      <p>被保险人在投保后至等待期结束之日前罹患本主险合同所附特定疾病清单定义的特定疾病的，我们不承担给付保险金的责任，本主险合同终止，我们向您无息退还所有保险费。</p>
      <p>4.本产品赔付比例：如投保时被保险人以有基本医疗保险或公费医疗的身份参保、但就诊时未使用基本医疗保险或公费医疗的，则赔付比例为60%；其他情况下，该赔付比例为100%（质子重离子附加包不受此限制）；</p>
      <p>5.免赔额余额：前次理赔经“保险责任范围内的医疗费用”抵扣剩余的免赔额。例：本产品免赔额为2万，第一次就诊累计的“保险责任范围内医疗费用”为8000，则针对本次就诊理赔后，免赔额余额为12000，本次赔付0；若第二次就诊累计的“保险责任范围内医疗费用”为16000，则针对本次就诊理赔后，免赔额余额为0，本次赔付4000。</p>
      <p>
        对保障内容还有疑问？猛戳
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/31/101.pdf">《适用条款》</a>
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/33/101.html">《重要声明》</a>
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/32/101.html">《责任免除》</a>
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/49/101.pdf">《医疗服务手册》</a>
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/provision/kaws_new_disease_service.pdf">《特药服务手册》</a>
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/45/101.html">《健康信用费率优惠说明》</a>
      </p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'feature',
  data() {
    return {
      name: '产品特色',
    }
  },
  props: {
  },
  computed: {
    
  },
  methods: {
    // 跳转到其他页面
    goToThirdPage(e) {
      let url = e.target.getAttribute('data-url');
      let title = e.target.text || '';
      this.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
          title: title
        }
      })
    },
  },
  created() {

  }
}
</script>

<style scoped lang="stylus">
  .comp-feature
    width: 100%
    background-color: #fff
    .cont
      padding-bottom: .25rem
      img
        display: block
        width: 100%
        height: 100%
        margin: 0 0
      p
        margin: .05rem .3rem
        color: #999
        font-size: .24rem
        line-height: .38rem
      .first
        padding-top: .25rem
</style>
